import { produce } from 'immer';
import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../../../common/widgets/Loader';
import LoadingSpinner from '../../../../common/widgets/LoadingSpinner';
import { InformationItem } from '../../models/information';
import { informationService } from '../../services/information';

interface InformationPageState {
  details?: InformationItem | null;
  isLoading: boolean;
}

export const InformationPage = () => {
  const { informationId } = useParams();
  const [state, setState] = useState<InformationPageState>({
    details: null,
    isLoading: true,
  });

  useEffect(() => {
    document.title = state?.details?.title ?? '';
  }, [state?.details?.title]);

  const loadInformation = useCallback(
    async (abortController?: AbortController) => {
      const result = await informationService.getInformation(
        Number(informationId),
        {
          signal: abortController?.signal,
        },
      );
      if (abortController?.signal.aborted) return;
      if (!result.hasErrors) {
        setState(
          produce(draft => {
            draft.details = result.data;
            draft.isLoading = false;
          }),
        );
      } else if (!abortController?.signal.aborted) {
        setState(
          produce(draft => {
            draft.isLoading = false;
          }),
        );
      }
    },
    [informationId],
  );

  useEffect(() => {
    const ac = new AbortController();
    loadInformation(ac);
    return () => ac.abort();
  }, [informationId, loadInformation]);

  return (
    <div className="m-panel">
      <Loader loading={state.isLoading} loader={<LoadingSpinner />}>
        {state.details?.html && (
          <div
            dangerouslySetInnerHTML={{
              __html: htmlDecode(state.details.html)!,
            }}
          />
        )}
      </Loader>
    </div>
  );
};

const htmlDecode = (input: string) => {
  const element = document.createElement('div');
  element.innerHTML = input;

  return element.childNodes.length === 0 ? '' : element.childNodes[0].nodeValue;
};
